import { useTranslation } from 'react-i18next';
import { Badge, InlineAlert } from '@scramble/ui';
import IconTicket from '@scramble/design-system/icons/ticket-01.svg'
import s from './index.module.scss';

export const RefferalCode = ({ code }) => {
  const { t } = useTranslation();

  if (!code) {
    return null;
  }

  return (
    <>
      <div className={s.referral}>
        <div className={s.referral_icon}>
          <img src={IconTicket} alt="icon" width={24} height={24} />
        </div>
        <div className={s.referral_content}>
          <span className="f-body-sm f-500">
            {t('auth:step_main.referral_code')}
          </span>
          <span className="f-body-md f-500">{code.id}</span>
        </div>
        <Badge
          label={t('auth:step_main.referral_code_applied')}
          type="success"
          appearance="filled"
          size="medium"
        />
      </div>
      <InlineAlert
        type="success"
        title={t('auth:step_main.referral_code_success')}
        message={t('auth:step_main.referral_code_register')}
      />
    </>
  );
};
